module.exports = __webpack_public_path__ + "static/img/dt.b3882a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dt.png
// module id = pQR1
// module chunks = 0